import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { LicensesRoutingModule } from './licenses-routing.module';
import { LicensesQuestionsService } from './services/licenses-questions.service';
import { LicensesListComponent } from './licenses-list/licenses-list.component';
import { LicenseDetailComponent } from './license-detail/license-detail.component';
import { LicenseEditorComponent } from './license-editor/license-editor.component';
import { LicenseReportComponent } from './license-report/license-report.component';
import { LicenseCloneService } from './services/license-clone.service';

import { EmailsModule } from '../emails/emails.module';
import { LicenseLogComponent } from './license-log/license-log.component';
import { LicensesActivityListComponent } from './licenses-activity-list/licenses-activity-list.component';
import { LicensesActivityReportService } from './services/licenses-activity-report.service';
import { LicenseSessionsService } from './services/license-sessions.service';

@NgModule({
  imports: [CommonModule, CoreModule, LicensesRoutingModule, EmailsModule],
  declarations: [
    LicenseReportComponent,
    LicensesListComponent,
    LicenseDetailComponent,
    LicenseEditorComponent,
    LicenseLogComponent,
    LicensesActivityListComponent
  ],
  exports: [LicensesActivityListComponent, LicensesListComponent, LicenseEditorComponent, LicenseLogComponent],
  providers: [LicenseCloneService, LicensesQuestionsService, LicensesActivityReportService, LicenseSessionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LicensesModule {}
